import { BaseModel } from '../../_base/crud';

export class Role extends BaseModel {
  id: number;
  companyID: number;
  title: string;
  template: string;
  permissions: number[];
  type: number;
  department_id: any;
  department_name: any;

  clear(): void {
    this.id = 0;
    this.companyID = 0;
    this.title = '';
    this.template = '';
    this.permissions = [];
    this.type = 0;
  }
}
